import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(duration);
dayjs.extend(relativeTime);

const useTimeLeft = (startTime) => {
  const now = dayjs();
  const end = dayjs(startTime);

  const durationMoment = dayjs.duration(end.diff(now));
  const seconds = durationMoment.asSeconds();

  if (seconds <= 0) return null;
  return dayjs.duration(seconds, 'seconds').humanize();
};

export default useTimeLeft;
